import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  max-height: 1500px;
  background: rgb(247, 247, 247);

  @media (max-width: 768px) {
    height: 80vh;
  }
`;

export const Content = styled.div`
  flex: 1;
  max-width: 50%;
  line-height: 1;
  padding-left: 10%;

  @media (max-width: 768px) {
    max-width: 40%;
    margin-bottom: 20px;
    padding-left: 5%;
  }

  h1 {
    font-size: 3.8rem;
    color: red;
    font-weight: bold;

    @media (max-width: 768px) {
      font-size: 1.2rem;
    }
  }

  p {
    font-size: 1.5rem;
    color: black;
    font-weight: bold;

    @media (max-width: 768px) {
      font-size: 0.8rem;
    }
  }
`;

export const Image = styled.div`
  margin-top: 20px;
  img {
    max-width: 100%;
    height: auto;
  }

  @media (max-width: 768px) {
    width: 50%;
  }
`;
